/*
 * @Description: logger
 * @Date: 2022-04-11 19:39:55
 * @LastEditTime: 2022-04-12 11:37:24
 */
import { LogLevelType, LogContext, getLogPrefix } from './logger-utils';
import { ItemAction, trackEvent } from "@/libs/analytics/analyticsEvents";
export * from './logger-utils';

const isDebugEnabled = process.env.NODE_ENV === "development";

let currentLogLevel = isDebugEnabled
  ? LogLevelType.LOG_LEVEL_DEBUG
  : LogLevelType.LOG_LEVEL_NON_LOGGING;

const extractErrorMessage = (args: any[]) => {
  const err = args.find((a) => a instanceof Error);
  return err?.message;
};

const createLoggerMethod = (
  level: number,
  consoleMethod: (...args: any[]) => void,
  logLevel: "debug" | "log" | "info" | "warn" | "error",
) => {
  return (message: string, ...args: any[]) => {
    if (currentLogLevel <= level) {
      consoleMethod(`${getLogPrefix(LogContext.RENDER)}`, message, ...args);
    }

    trackEvent({
      action: ItemAction.LOG,
      log_level: logLevel,
      message,
      error_message: extractErrorMessage(args) || "",
    });
  };
};

export const logger = {
  /** Print debug logs when current level allows debug output. */
  debug: createLoggerMethod(
    LogLevelType.LOG_LEVEL_DEBUG,
    console.debug,
    "debug",
  ),
  /** Print standard logs when current level allows log output. */
  log: createLoggerMethod(LogLevelType.LOG_LEVEL_LOG, console.log, "log"),
  /** Print info logs when current level allows info output. */
  info: createLoggerMethod(LogLevelType.LOG_LEVEL_INFO, console.info, "info"),
  /** Print warning logs when current level allows warn output. */
  warn: createLoggerMethod(LogLevelType.LOG_LEVEL_WARN, console.warn, "warn"),
  /** Print error logs when current level allows error output. */
  error: createLoggerMethod(
    LogLevelType.LOG_LEVEL_ERROR,
    console.error,
    "error",
  ),
  /** Update current log level at runtime. */
  setLevel(newLevel: number) {
    if (
      newLevel >= LogLevelType.LOG_LEVEL_DEBUG &&
      newLevel <= LogLevelType.LOG_LEVEL_NON_LOGGING
    ) {
      console.log(
        `${getLogPrefix(
          LogContext.RENDER
        )} set log level from ${currentLogLevel} to ${newLevel}`
      );
      currentLogLevel = newLevel;
    } else {
      console.error(
        `${getLogPrefix(
          LogContext.RENDER
        )} logger.setLevel() invalid params:${newLevel}`
      );
    }
  },
  /** Get current active log level. */
  getLevel() {
    return currentLogLevel;
  },
};
